import React from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout = ({ children }: MainLayoutProps) => {
  const location = useLocation();
  const isRiverHacksPage = location.pathname === '/riverhacks';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <ScrollToTop />
      {!isRiverHacksPage && <Header />}
      <Box
        component="main"
        id="main-content"
        role="main"
        sx={{
          flexGrow: 1,
          pt: isRiverHacksPage ? 0 : { xs: 8, md: 10 },
        }}
      >
        {children}
      </Box>
      <Footer />
    </Box>
  );
};

export default MainLayout; 